import { Card, Divider } from "antd";

import VerifyEmailForm from "./components/verifyEmailForm";
import { styles } from "./styles/verifyEmailStyles";
import logo from "../../assets/images/airp_logo.png";
import dayjs from "../../config/dayjs";

export default function VerifyEmailPage() {
  return (
    <div style={styles.container}>
      <div style={{ width: "100%" }}>
        <div style={styles.logoContainer}>
          <img alt="logo" src={logo} style={styles.logo} />
        </div>
        <Card title="Verify Email" style={styles.verifyEmailCard}>
          <VerifyEmailForm />
          <Divider />
          <div style={styles.copyright}>© AIRP {dayjs().year()}</div>
        </Card>
      </div>
    </div>
  );
}
